import * as React from "react";
/**
 * Set the document title for the active screen
 */ export default function useDocumentTitle(ref) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_enabled = _ref.enabled, enabled = _ref_enabled === void 0 ? true : _ref_enabled, _ref_formatter = _ref.formatter, formatter = _ref_formatter === void 0 ? function(options, route) {
        var _options_title;
        return (_options_title = options === null || options === void 0 ? void 0 : options.title) !== null && _options_title !== void 0 ? _options_title : route === null || route === void 0 ? void 0 : route.name;
    } : _ref_formatter;
    React.useEffect(function() {
        if (!enabled) {
            return;
        }
        var navigation = ref.current;
        if (navigation) {
            var title = formatter(navigation.getCurrentOptions(), navigation.getCurrentRoute());
            document.title = title;
        }
        return navigation === null || navigation === void 0 ? void 0 : navigation.addListener("options", function(e) {
            var title = formatter(e.data.options, navigation === null || navigation === void 0 ? void 0 : navigation.getCurrentRoute());
            document.title = title;
        });
    });
}
